export enum LocationsActionTypes {
  API_RESPONSE_SUCCESS = "@@locations/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@locations/API_RESPONSE_ERROR",

  GET_LOCATIONS = "@@locations/GET_LOCATIONS",
  UPDATE_LOCATIONS = "@@locations/UPDATE_LOCATIONS",
  ADD_LOCATIONS = "@@locations/ADD_LOCATIONS",
  DELETE_LOCATIONS = "@@locations/DELETE_LOCATIONS",
  CLEAR_ERROR = "@@locations/CLEAR_ERROR",
}
